import { tns } from 'tiny-slider/src/tiny-slider';

/**
 * Slider Module
 * utilizes TinySlider package
 * to get things sliding
 */
export default class {
  /**
   * create TinySlider instance and wire navigation styling callbacks up
   */
  constructor() {
    this.caller = document.querySelector('#aktuelles-urteil');

    if (this.caller) {
      this.slider = tns({
        container: '[data-judge-slider]',
        items: 1,
        slideBy: 'page',
        controls: true,
        controlsPosition: 'bottom',
        arrowKeys: true,
        nav: true,
        navPosition: 'bottom',
        navContainer: '[data-judge-nav]',
        loop: false,
        mouseDrag: true,
        prevButton: '[data-judge-prev]',
        nextButton: '[data-judge-next]',
        gutter: 20,
        preventScrollOnTouch: 'auto',
        onInit: (info) => this.updatePagination(info),
        responsive: {
          640: {
            items: 2,
            slideBy: 2,
          },
          1024: {
            items: 3,
            slideBy: 3,
          },
        },
      });

      this.slider.events.on('indexChanged', (info) => this.updatePagination(info));
    }
  }

  /**
   * jQuery .index() in plain js
   * @see https://stackoverflow.com/a/13658035
   * @param {HTMLElement} element
   * @return {Number} -1 or zero based index of element
   */
  elementIndex(element) { // eslint-disable-line class-methods-use-this
    const children = element.parentNode.childNodes;
    let num = 0;
    for (let i = 0, j = children.length; i < j; i += 1) {
      if (children[i] === element) {
        return num;
      }
      if (children[i].nodeType === 1) {
        num += 1;
      }
    }
    return -1;
  }

  /**
   * @function updatePagination
   * @param {Object} info - getInfo() of tiny-slider .
   */
  updatePagination({
    pages,
    navContainer,
  }) {
    const pageIndex = this.elementIndex(document.querySelector('.judgments .tns-nav-active'));

    // setup pages visibility
    navContainer.children.forEach((navChild, index) => {
      navChild.classList.remove('judgments__nav-button--before-dots');
      navChild.classList.remove('judgments__nav-button--after-dots');

      // show last and first page
      if (index === 0 || index === pages - 1) {
        navChild.hidden = false; // eslint-disable-line no-param-reassign
      } else {
        navChild.hidden = true; // eslint-disable-line no-param-reassign
      }

      if (index >= pages) {
        return;
      }

      // check if item should be visible with dots
      if ([pageIndex - 1, pageIndex, pageIndex + 1].indexOf(index) !== -1 || pages <= 5) {
        navChild.hidden = false; // eslint-disable-line no-param-reassign

        if (pages > 5) {
          if (index === pageIndex - 1 && index > 1) {
            navChild.classList.add('judgments__nav-button--before-dots');
          }
          if (index === pageIndex + 1 && index < pages - 2) {
            navChild.classList.add('judgments__nav-button--after-dots');
          }
        }
      }
    });
  }
}
